/* VITALLY · selector de 30 minutos (Salud y orientación). Elige día y hora y
   confirma por WhatsApp con el mensaje escrito. Los días se calculan en el
   navegador; los domingos se saltan salvo que la sección diga lo contrario. */
(function () {
  "use strict";
  var DIAS = ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"];
  var MESES = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
  var wa = document.body.getAttribute("data-wa") || "";
  var ACTIVO = "border-oro bg-bosque text-oroclaro";
  var QUIETO = "border-pergamino bg-marfil text-humo hover:border-oro/60 hover:text-tinta";
  var BASE = "min-h-[44px] rounded-xl border px-4 py-2 text-[0.82rem] font-bold transition-colors disabled:cursor-not-allowed disabled:opacity-45 ";

  document.querySelectorAll("[data-agenda]").forEach(function (caja) {
    var contexto = caja.getAttribute("data-contexto") || "";
    var horas = (caja.getAttribute("data-horas") || "").split(",").map(function (h) { return h.trim(); }).filter(Boolean);
    var cuantos = Number(caja.getAttribute("data-dias")) || 6;
    var domingo = caja.getAttribute("data-domingo") === "true";
    var cajaDias = caja.querySelector("[data-agenda-dias]");
    var cajaHoras = caja.querySelector("[data-agenda-horas]");
    var confirmar = caja.querySelector("[data-agenda-confirmar]");
    var nota = caja.querySelector("[data-agenda-nota]");
    var notaInicial = nota.textContent;
    var dias = [];
    var d = new Date();
    while (dias.length < cuantos) {
      d.setDate(d.getDate() + 1);
      if (d.getDay() === 0 && !domingo) continue;
      dias.push({ id: d.toISOString().slice(0, 10), dia: DIAS[d.getDay()], num: d.getDate(), mes: MESES[d.getMonth()] });
    }
    var elegidoDia = null;
    var elegidaHora = null;

    function pintar() {
      cajaDias.innerHTML = dias.map(function (x) {
        var on = elegidoDia && elegidoDia.id === x.id;
        return '<button type="button" data-dia="' + x.id + '" aria-pressed="' + !!on + '" class="' + BASE + "text-left " + (on ? ACTIVO : QUIETO) + '"><span class="block capitalize">' + x.dia + '</span><span class="block text-[0.7rem] font-semibold opacity-80">' + x.num + " de " + x.mes + "</span></button>";
      }).join("");
      cajaHoras.innerHTML = horas.map(function (h) {
        var on = elegidaHora === h;
        return '<button type="button" data-hora="' + h + '" aria-pressed="' + on + '"' + (elegidoDia ? "" : " disabled") + ' class="' + BASE + (on ? ACTIVO : QUIETO) + '">' + h + "</button>";
      }).join("");
      var listo = !!(elegidoDia && elegidaHora);
      confirmar.classList.toggle("pointer-events-none", !listo);
      confirmar.classList.toggle("opacity-45", !listo);
      confirmar.setAttribute("aria-disabled", listo ? "false" : "true");
      confirmar.querySelector("span").textContent = confirmar.getAttribute(listo ? "data-listo" : "data-pendiente");
      if (listo) {
        var cuando = elegidoDia.dia + " " + elegidoDia.num + " de " + elegidoDia.mes;
        confirmar.href = wa + encodeURIComponent("Hola, quiero reservar mi " + contexto.toLowerCase() + " de 30 minutos el " + cuando + " a las " + elegidaHora + ".");
        nota.textContent = (nota.getAttribute("data-resumen") || "").replace("[dia]", elegidoDia.dia + " " + elegidoDia.num).replace("[hora]", elegidaHora);
      } else {
        confirmar.href = "#";
        nota.textContent = notaInicial;
      }
    }

    caja.addEventListener("click", function (e) {
      var bd = e.target.closest("[data-dia]");
      var bh = e.target.closest("[data-hora]");
      if (bd) {
        elegidoDia = dias.filter(function (x) { return x.id === bd.getAttribute("data-dia"); })[0];
        pintar();
      } else if (bh) {
        elegidaHora = bh.getAttribute("data-hora");
        pintar();
      } else if (e.target.closest("[data-agenda-confirmar]") && !(elegidoDia && elegidaHora)) {
        e.preventDefault();
      }
    });
    pintar();
  });
})();
